export const expertise = [ 
    {},
    {label: 'Accounting & Finance', value: 'Accounting & Finance'},
    {label: 'Advertising & Marketing', value: 'Advertising & Marketing'},
    {label: 'Business & Systems Analysis', value: 'Business & Systems Analysis'},
    {label: 'Data Science, Analytics & Intelligence', value: 'Data Science, Analytics & Intelligence'},
    {label: 'Executive Management', value: 'Executive Management'},
    {label: 'Hardware, Network and IoT Engineering', value: 'Hardware, Network and IoT Engineering'},
    {label: 'Information Security & Cybersecurity', value: 'Information Security & Cybersecurity'},
    {label: 'Innovation & Entrepreneurship', value: 'Innovation & Entrepreneurship'},
    {label: 'IT Operations', value: 'IT Operations'},
    {label: 'Legal & Operations', value: 'Legal & Operations'},
    {label: 'Other - Business', value: 'Other - Business'},
    {label: 'Other - Engineering', value: 'Other - Engineering'},
    {label: 'Other - IT', value: 'Other - IT'},
    {label: 'Other - Technical', value: 'Other - Technical'},
    {label: 'People Management', value: 'People Management'},
    {label: 'PR & Media', value: 'PR & Media'},
    {label: 'Project & Product Management', value: 'Project & Product Management'},
    {label: 'Quality Engineering & Testing', value: 'Quality Engineering & Testing'},
    {label: 'Recruitment & Human Resources', value: 'Recruitment & Human Resources'},
    {label: 'Sales & Account Management', value: 'Sales & Account Management'},
    {label: 'Software Engineering', value: 'Software Engineering'},
    {label: 'UI/UX & Graphic Design', value: 'UI/UX & Graphic Design'},
]